import { render, staticRenderFns } from "./QUserBadges.vue?vue&type=template&id=49da0b3a&"
import script from "./QUserBadges.vue?vue&type=script&lang=js&"
export * from "./QUserBadges.vue?vue&type=script&lang=js&"
import style0 from "./QUserBadges.vue?vue&type=style&index=0&id=49da0b3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports